import { Component, Injector, OnInit } from '@angular/core';
import { SimpleModalService } from '@looorent/ngx-simple-modal';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { UntypedFormArray, } from '@angular/forms';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { ModelSelectorComponent } from '../../../../shared/modals/ModelSelector/modelselector.component';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';
import { AddVehicleComponent } from 'src/app/features/users/users/modals/add-vehicle/add-vehicle.component';
import { OrganizationsService } from 'src/app/Services/organizations.service';
import { GlobalAddVehicleComponent } from 'src/app/shared/modals/global-add-vehicle/global-add-vehicle.component';

@Component({
    selector: 'app-editparkingpermit',
    templateUrl: './editparkingpermit.component.html',
    styleUrls: ['./editparkingpermit.component.scss'],
    standalone: false
})
export class EditParkingPermitComponent extends ModelEditor implements OnInit {

  public PermitTypes: any[] = [];
  public RenewDate: string = "";
  public orgService !: OrganizationsService;
  public IsAddingNewUser: boolean = false;
  public IsAddingNewMultiUser: boolean = false;
  public NewMultiUserFirstName: string = "";
  public NewMultiUserLastName: string = "";
  public NewMultiUserEmail: string = "";

  constructor(private modalService: SimpleModalService, private apiService: ApiServiceBase, private injector: Injector, public orgservice: OrganizationsService) {
    super("permits", injector);

    this.orgService = orgservice;

    this.apiService.Get<any>("permits/standardpermittypes").then(result => {
      this.PermitTypes = result;
    });
  }

  public override DefaultModel(): any {
    return {
      ParkingPermitInstanceCount: 0,
      StartDateLocal: null,
      EndDateLocal: null,
      ParkingPermitTypeId: null,
      ParkingPermitType: { Id: null, MultiUser: false},
      ParkingSpaceId: null,
      ParkingSpaceLocationString: null,
      ClassName: null,
      Invitees: [],
      Vehicles: [],
      ParkingPermitUsers: [],
      UserId: null,
      FullName: null,
      FirstName: null,
      LastName: null,
      EmailAddress: null
    }
  }

  public isSingleUserPermit(): boolean {
    return this.Model?.ClassName === 'SingleUserParkingPermit';
  }

  public isMultiUserPermit(): boolean {
    return this.Model?.ClassName === 'MultiUserParkingPermit';
  }

  private stripTimeFromDate(name: string) {
    var formControl = this.Form.get(name);
    if (formControl?.value) {
      const dateValue = formControl.value;
      if (typeof dateValue === 'string' && dateValue.includes('T')) {
        formControl.setValue(dateValue.split('T')[0], { emitEvent: false });
      }
    }
  }

  public override AfterModelLoaded(): void {
    // Handle users based on permit type
    if (this.isMultiUserPermit()) {
      // For multi-user permits, ensure ParkingPermitUsers array exists
      if (!this.Model.ParkingPermitUsers || this.Model.ParkingPermitUsers.length == 0) {
        this.Model.ParkingPermitUsers = [];
      }
      // Ensure IsOwner and IsInvitee are set on existing users
      if (this.Model.ParkingPermitUsers && this.Model.ParkingPermitUsers.length > 0) {
        this.Model.ParkingPermitUsers = this.Model.ParkingPermitUsers.map((user: any) => ({
          ...user,
          IsOwner: user.IsOwner ?? false,
          IsInvitee: user.IsInvitee ?? false
        }));
      }
      // Reset the new user flag when loading
      this.IsAddingNewMultiUser = false;
    } else if (this.isSingleUserPermit()) {
      // For single-user permits, FullName is already on the model
      // No additional processing needed
      // Reset the new user flag when loading
      this.IsAddingNewUser = false;
    }

    if(this.Form.get('ParkingPermitTypeId')?.value != null){
      this.apiService.Get("permits/standardpermittypes/"+this.Form.get('ParkingPermitTypeId')?.value).then((result: any) => {
        this.Model.ParkingPermitType = result;
        this.Model.ParkingPermitType.Restriction = this.BuildRestrictionString();
      });
    }


    this.stripTimeFromDate('StartDateLocal');
    this.stripTimeFromDate('EndDateLocal');

    // Disable ParkingPermitTypeId if editing an existing permit
    if (!this.ModelIsNew) {
      this.Form.get('ParkingPermitTypeId')?.disable();
    }


  }

  public UpdateParkingPermitType(){
    var pt = this.PermitTypes.filter((x: any) => x.Id == this.Form.get('ParkingPermitTypeId')?.value)[0];
    this.Loading();
    this.apiService.Get<any>("permits/standardpermittypes/" + pt.Id).then(result => {
      this.Model.ParkingPermitType = result;
      this.Model.ParkingPermitTypeId = pt.Id;
      this.Model.ParkingPermitType.Restriction = this.BuildRestrictionString();
      if (this.Model.ParkingPermitType.IsMultiUser){
        this.Form.get('ClassName')?.setValue("MultiUserParkingPermit");
        this.Model.ClassName = "MultiUserParkingPermit";
      }
      else{
        this.Form.get('ClassName')?.setValue("SingleUserParkingPermit");
        this.Model.ClassName = "SingleUserParkingPermit";
      }
      // Reset adding new user flags when permit type changes
      this.IsAddingNewUser = false;
      this.IsAddingNewMultiUser = false;
      this.StopLoading();
    });
  }

  public override BeforeSave(): void {

  }
  public override Validators(): any {
  }

  public override CanDeactivate(): boolean {
    return true;
  }


  public BuildRestrictionString(){
    var string = [];
    if(this.Model.ParkingPermitType.RestrictToUserRoles && this.Model.ParkingPermitType.RoleRestrictions.length > 0){
    string.push("This permit is restricted to Users who have the User Roles: ");
      for (let i = 0; i < this.Model.ParkingPermitType.RoleRestrictions.length ; i++) {
        string.push((i == 0 ? '' : (i == this.Model.ParkingPermitType.RoleRestrictions.length-1 ? ', and ': ',')) + this.Model.ParkingPermitType.RoleRestrictions[i].RoleName);
      }
      string.push(". ");
    }
    var limitedToPushed = false;
    if(this.Model.ParkingPermitType.MaxUsesPerPeriod != null && this.Model.ParkingPermitType.MaxUsesPerPeriod != 0 && this.Model.ParkingPermitType.MaxUsePeriodString != null){
      string.push(string.length > 0 ? "There is a maximum of " : "This permit has a maximum of ");
      limitedToPushed = true;
      string.push(this.Model.ParkingPermitType.MaxUsesPerPeriod + " uses " + this.Model.ParkingPermitType.MaxUsePeriodString);
    }

    if(this.Model.ParkingPermitType.LimitToSpaceTypes && this.Model.ParkingPermitType.SpaceTypeRestrictions.length > 0){
      if(limitedToPushed) string.push(" in ");
      else {
        string.push(string.length > 0 ? "It is limited to use in " : "This Permit is limited to use in ");
        limitedToPushed = true;
      }
      for (let i = 0; i < this.Model.ParkingPermitType.SpaceTypeRestrictions.length ; i++) {
        string.push((i == 0 ? '' : (i == this.Model.ParkingPermitType.SpaceTypeRestrictions.length-1 ? ', and ': ',')) + "'" + this.Model.ParkingPermitType.SpaceTypeRestrictions[i].SpaceTypeName + "'");
      }
      string.push(" Parking Spaces");
    }

    if(this.Model.ParkingPermitType.ParkingStructures?.length > 0){
      if(limitedToPushed) string.push(" in the following parking structures: ");
      else {
        string.push("This Permit is limited to use the following parking structures: ");
      }
      for (let i = 0; i < this.Model.ParkingPermitType.ParkingStructures.length ; i++) {
        string.push((i == 0 ? '' : (i == this.Model.ParkingPermitType.ParkingStructures.length-1 ? ', and ': ',')) + "'" + this.Model.ParkingPermitType.ParkingStructures[i].LocationString + "'");
      }
    }
    string.push(". ")
    var str = string.join("");
    if(str == ". ") str = "There are no restrictions on this permit.";
    return str;
  }

  public canAddUser(): boolean {
    if (!this.Model.ParkingPermitType) return false;
    
    // For multi-user permits, check against max users
    if (this.Model.ParkingPermitType?.IsMultiUser) {
      if (this.IsAddingNewMultiUser) return false;
      const currentTotal = (this.Form.get('ParkingPermitUsers')?.value?.length || 0) + (this.Form.get('Invitees')?.value?.length || 0);
      return currentTotal < (this.Model.ParkingPermitType.MaxUsers || 999);
    }
    
    // For single user permits, only allow if UserId is not set and not adding a new user
    return !this.Form.get('UserId')?.value && !this.IsAddingNewUser;
  }

  public canAddInvitee(): boolean {
    if (!this.Model.ParkingPermitType) return false;
    
    // For multi-user permits, check against max users
    if (this.Model.ParkingPermitType?.IsMultiUser) {
      const currentTotal = (this.Form.get('ParkingPermitUsers')?.value?.length || 0) + (this.Form.get('Invitees')?.value?.length || 0);
      return currentTotal < (this.Model.ParkingPermitType.MaxUsers || 999);
    }
    
    // Invitees only exist for multi-user permits
    return false;
  }

  public AddUser(){
    this.modalService.addModal(ModelSelectorComponent,
      { ApiUrl: "users/searches", ModelType: "User", 
        Columns: [
          new Datalistviewcolumn("Name", "Name"),
          new Datalistviewcolumn("Email", "Email")
        ]
      })
      .subscribe((result) => {
        if (result != null) {
          if (this.isMultiUserPermit()) {
            // Check for duplicates before adding
            const users = this.FormArray(this.Form, "ParkingPermitUsers");
            const isDuplicate = users.controls.some((userControl: any) => {
              const userId = userControl.get('UserId')?.value;
              const email = userControl.get('Email')?.value;
              return userId === result.Id || (email && result.Email && email.toLowerCase() === result.Email.toLowerCase());
            });

            if (isDuplicate) {
              this.toast.warning('This user is already in the list', 'Duplicate User');
              return;
            }

            // For multi-user permits, add to ParkingPermitUsers array
            let u = { 
              Id: null, 
              UserId: result.Id, 
              FirstName: result.FirstName, 
              LastName: result.LastName,
              Email: result.Email,
              IsPurchaser: false,
              IsInvitee: false
            };
            this.AddToFormArray(this.Form.get('ParkingPermitUsers') as UntypedFormArray, u, "ParkingPermitUsers");
          } else if (this.isSingleUserPermit()) {
            // For single-user permits, set UserId and FullName
            this.Form.get('UserId')?.setValue(result.Id);
            this.Form.get('FullName')?.setValue(result.FirstName + ' ' + result.LastName);
            this.Form.markAsDirty();
          }
        }
      });
  }

  public AddInvitee(){
    let u = { Id: null, UserId: null, FirstName: null, LastName:null, Email:null};
    this.AddToFormArray(this.Form.get('Invitees') as UntypedFormArray, u, "Invitees");
  }

  public removeUser(index?: number){
    if (this.isMultiUserPermit() && index !== undefined) {
      this.FormArray(this.Form, "ParkingPermitUsers").removeAt(index);
    } else if (this.isSingleUserPermit()) {
      this.Form.get('UserId')?.setValue(null);
      this.Form.get('FullName')?.setValue(null);
      this.Form.get('FirstName')?.setValue(null);
      this.Form.get('LastName')?.setValue(null);
      this.Form.get('EmailAddress')?.setValue(null);
      this.IsAddingNewUser = false;
    }
    this.Form?.markAsDirty();
  }

  public startAddingNewUser(){
    this.IsAddingNewUser = true;
    this.Form.get('UserId')?.setValue(null);
    this.Form.get('FullName')?.setValue(null);
    this.Form.markAsDirty();
  }

  public cancelAddingNewUser(){
    this.IsAddingNewUser = false;
    this.Form.get('FirstName')?.setValue(null);
    this.Form.get('LastName')?.setValue(null);
    this.Form.get('EmailAddress')?.setValue(null);
    this.Form.markAsDirty();
  }

  public startAddingNewMultiUser(){
    this.IsAddingNewMultiUser = true;
    this.NewMultiUserFirstName = "";
    this.NewMultiUserLastName = "";
    this.NewMultiUserEmail = "";
  }

  public cancelAddingNewMultiUser(){
    this.IsAddingNewMultiUser = false;
    this.NewMultiUserFirstName = "";
    this.NewMultiUserLastName = "";
    this.NewMultiUserEmail = "";
  }

  public saveNewMultiUser(){
    if (!this.NewMultiUserFirstName || !this.NewMultiUserLastName || !this.NewMultiUserEmail) {
      return;
    }

    // Check for duplicates before adding
    const users = this.FormArray(this.Form, "ParkingPermitUsers");
    const isDuplicate = users.controls.some((userControl: any) => {
      const email = userControl.get('Email')?.value;
      return email && email.toLowerCase() === this.NewMultiUserEmail.toLowerCase();
    });

    if (isDuplicate) {
      this.toast.warning('A user with this email address is already in the list', 'Duplicate User');
      return;
    }

    let u = { 
      Id: null, 
      UserId: null, 
      FirstName: this.NewMultiUserFirstName, 
      LastName: this.NewMultiUserLastName,
      Email: this.NewMultiUserEmail,
      IsPurchaser: false,
      IsInvitee: false
    };
    this.AddToFormArray(this.Form.get('ParkingPermitUsers') as UntypedFormArray, u, "ParkingPermitUsers");
    
    this.IsAddingNewMultiUser = false;
    this.NewMultiUserFirstName = "";
    this.NewMultiUserLastName = "";
    this.NewMultiUserEmail = "";
  }

  public toggleIsOwner(index: number){
    const users = this.FormArray(this.Form, "ParkingPermitUsers");
    const targetUser = users.at(index);
    const currentValue = targetUser.get('IsPurchaser')?.value;
    
    // If setting to true, clear IsOwner from all other users
    if (!currentValue) {
      for (let i = 0; i < users.length; i++) {
        users.at(i).get('IsPurchaser')?.setValue(false);
      }
    }
    
    // Toggle the target user's IsOwner
    targetUser.get('IsPurchaser')?.setValue(!currentValue);
    this.Form.markAsDirty();
  }

  public toggleIsInvitee(index: number){
    const users = this.FormArray(this.Form, "ParkingPermitUsers");
    const targetUser = users.at(index);
    const currentValue = targetUser.get('IsInvitee')?.value;
    
    targetUser.get('IsInvitee')?.setValue(!currentValue);
    this.Form.markAsDirty();
  }

  public removeInvitee(index: number){
    this.FormArray(this.Form, "Invitees").removeAt(index);
    this.Form?.markAsDirty();
  }

  public BuildUsersString(){
    if(!this.Model.ParkingPermitType?.IsMultiUser) return 'Single User Permit';
    var str = 'Multi User Permit';
    if(this.Model.ParkingPermitType?.MinUsers == null && this.Model.ParkingPermitType?.MaxUsers == null) return str + ' (Any number of users)';
    if(this.Model.ParkingPermitType?.MinUsers == null) return str + ' (At most ' + this.Model.ParkingPermitType?.MaxUsers + ' users)';
    if(this.Model.ParkingPermitType?.MaxUsers == null) return str + ' (At least ' + this.Model.ParkingPermitType?.MinUsers + ' users)';
    return str + ' (' + this.Model.ParkingPermitType?.MinUsers + ' to ' + this.Model.ParkingPermitType?.MaxUsers + ' users)'
  }

  public UserChanged(MultiUserResponse : any){

    var User = MultiUserResponse.User;
    var formGroup = MultiUserResponse.FormGroup;

    formGroup.get('Email').setValue(User.Email);
    formGroup.get('FirstName').setValue(User.FirstName);
    formGroup.get('LastName').setValue(User.LastName);
    formGroup.get('UserId').setValue(User.Id);
  }

  public DeleteUser(MultiUserResponse : any){
    var index = MultiUserResponse.Index;
    this.FormArray(this.Form, "ParkingPermitUsers").removeAt(index);
  }

  public DeleteParkingSpaceId(){
    this.Form.get('ParkingSpaceId')?.setValue(null);
  }

  public ParkingSpaceColumns : Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("Name", "Name"),
    new Datalistviewcolumn("Location", "LocationString")
  ];


  public VehicleColumns : Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("Name", "Name"),
    new Datalistviewcolumn("Description", "Description"),
    new Datalistviewcolumn("Plate Number", "PlateNumber")
  ];

  public AddParkingSpace(){
    this.modalService.addModal(ModelSelectorComponent,
      { ApiUrl: "parking/permittypes/" + this.Form.get('ParkingPermitTypeId')?.value +"/spaces/searches", ModelType: "Parking Space", 
        Columns : this.ParkingSpaceColumns
      })
      .subscribe((result) => {
        if (result != null) {
            this.Form.get('ParkingSpaceId')?.setValue(result.Id);
            this.Form.get('ParkingSpaceLocationString')?.setValue(result.LocationString);
          }
      })
  };

  public RemoveVehicle(index: any){
    this.FormArray(this.Form, "Vehicles").removeAt(index);
    this.Form.markAsDirty();
  }

  public AddVehicle(){
      this.modalService.addModal(GlobalAddVehicleComponent).subscribe(result => {
        console.log(result);
        this.AddToFormArray(this.FormArray(this.Form, "Vehicles"), {VehicleId: result.Id, PlateNumber: result.PlateNumber, Model: result.Model, Color: result.Color, Brand: result.Brand }, "Vehicles")
      })
  };
}
